export default __webpack_public_path__ + "static/media/filter-icon-insight.3d59299f.svg";